import Interaction from "../../../models/interactions/Interaction";
import NodeToggle from "../components/NodeToggle";
import useUpdateSequenceInteraction from "./UpdateSequenceInteraction.hook";
import { ISequence } from "../../../models/interactions/Sequence";

export default function SequenceNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  const interaction = props.interaction as ISequence;
  const { updateInteraction } = useUpdateSequenceInteraction();

  return (
    <div className="w-full h-full flex flex-col gap-[12px]">
      <NodeToggle
        label="Finish All"
        value={interaction.finishAll}
        onChange={(finishAll) =>
          updateInteraction(props.nodeId, {
            ...interaction,
            finishAll,
          } as ISequence)
        }
      />
      <NodeToggle
        label="Abort Others on Finish"
        value={interaction.abortOthersOnFinish}
        onChange={(abortOthersOnFinish) =>
          updateInteraction(props.nodeId, {
            ...interaction,
            abortOthersOnFinish,
          } as ISequence)
        }
      />
    </div>
  );
}
